module.exports = function getResource(label, vars = []) {
    let resources = {
        selectYourSamplesText: 'Sélectionnez votre ou vos échantillon(s)',
        getText: 'Obtenir ',
        freeSamplesWithEveryOrderText: ' échantillon(s) gratuit(s) avec chaque commande'
    };

    return resources[label];
};
